"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Others = function Others() {
  return _react2.default.createElement(
    "g",
    { id: "others" },
    _react2.default.createElement("path", {
      d: "M146.8,25.5 C173.2,8.5 205.7,0 244.2,0 C294.8,0 336.8,12.1 370.3,36.3 C403.7,60.5 420.5,96.3 420.5,143.8 C420.5,172.9 413.2,197.4 398.7,217.3 C390.2,229.4 373.9,244.8 349.8,263.6 L326,282.1 C313.1,292.2 304.4,303.9 300.2,317.4 C297.5,325.9 296.1,339.1 295.9,357 L204.9,357 C206.2,319.2 209.8,293 215.6,278.6 C221.4,264.2 236.4,247.6 260.4,228.7 L284.9,209.6 C292.9,203.6 299.4,196.9 304.3,189.8 C313.2,177.5 317.7,163.9 317.7,149.2 C317.7,132.2 312.7,116.7 302.8,102.7 C292.9,88.7 274.7,81.7 248.4,81.7 C222.5,81.7 204.1,90.3 193.3,107.6 C182.5,124.8 177.1,142.8 177.1,161.3 L80.1,161.3 C82.7,97.4 105,52.2 146.8,25.5 Z M202.6,403 L303,403 L303,500 L202.6,500 L202.6,403 Z",
      id: "Shape"
    })
  );
};

exports.default = Others;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Others.js
// module id = 2972
// module chunks = 4